import { FC } from "react";

export const FolderIcon: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask id="path-1-inside-1_4083_29762" fill="white">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.33333 1.25C1.49238 1.25 0 2.74239 0 4.58334V8.25V8.31416V13.4167C0 15.2835 0 16.2169 0.363312 16.93C0.68289 17.5572 1.19282 18.0671 1.82003 18.3867C2.53307 18.75 3.46649 18.75 5.33333 18.75H14.6667C16.5335 18.75 17.4669 18.75 18.18 18.3867C18.8072 18.0671 19.3171 17.5572 19.6367 16.93C20 16.2169 20 15.2835 20 13.4167V8.25C20 6.38316 20 5.44974 19.6367 4.7367C19.3171 4.10949 18.8072 3.59956 18.18 3.27998C17.4669 2.91667 16.5335 2.91667 14.6667 2.91667H11.0716C9.49922 2.91667 8.00198 1.25 6.42957 1.25H3.33333Z"
        />
      </mask>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.33333 1.25C1.49238 1.25 0 2.74239 0 4.58334V8.25V8.31416V13.4167C0 15.2835 0 16.2169 0.363312 16.93C0.68289 17.5572 1.19282 18.0671 1.82003 18.3867C2.53307 18.75 3.46649 18.75 5.33333 18.75H14.6667C16.5335 18.75 17.4669 18.75 18.18 18.3867C18.8072 18.0671 19.3171 17.5572 19.6367 16.93C20 16.2169 20 15.2835 20 13.4167V8.25C20 6.38316 20 5.44974 19.6367 4.7367C19.3171 4.10949 18.8072 3.59956 18.18 3.27998C17.4669 2.91667 16.5335 2.91667 14.6667 2.91667H11.0716C9.49922 2.91667 8.00198 1.25 6.42957 1.25H3.33333Z"
        fill="#E4A02F"
      />
      <path
        d="M0.363312 16.93L0.734564 16.7408H0.734564L0.363312 16.93ZM1.82003 18.3867L2.00919 18.0154L2.00919 18.0154L1.82003 18.3867ZM18.18 18.3867L17.9908 18.0154L17.9908 18.0154L18.18 18.3867ZM19.6367 16.93L19.2654 16.7408V16.7408L19.6367 16.93ZM19.6367 4.7367L20.0079 4.54754V4.54754L19.6367 4.7367ZM18.18 3.27998L18.3691 2.90873V2.90873L18.18 3.27998ZM0.416667 4.58334C0.416667 2.9725 1.7225 1.66667 3.33333 1.66667V0.833333C1.26226 0.833333 -0.416667 2.51227 -0.416667 4.58334H0.416667ZM0.416667 8.25V4.58334H-0.416667V8.25H0.416667ZM0.416667 8.31416V8.25H-0.416667V8.31416H0.416667ZM0.416667 13.4167V8.31416H-0.416667V13.4167H0.416667ZM0.734564 16.7408C0.587825 16.4528 0.504006 16.1021 0.460697 15.5721C0.416991 15.0371 0.416667 14.357 0.416667 13.4167H-0.416667C-0.416667 14.3432 -0.416991 15.0632 -0.369869 15.6399C-0.32235 16.2215 -0.224514 16.6941 -0.00794114 17.1191L0.734564 16.7408ZM2.00919 18.0154C1.46039 17.7358 1.0142 17.2896 0.734564 16.7408L-0.00794122 17.1191C0.351584 17.8247 0.925261 18.3984 1.63087 18.7579L2.00919 18.0154ZM5.33333 18.3333C4.39304 18.3333 3.71287 18.333 3.17794 18.2893C2.64786 18.246 2.29719 18.1622 2.00919 18.0154L1.63087 18.7579C2.05592 18.9745 2.52847 19.0723 3.11008 19.1199C3.68682 19.167 4.40679 19.1667 5.33333 19.1667V18.3333ZM14.6667 18.3333H5.33333V19.1667H14.6667V18.3333ZM17.9908 18.0154C17.7028 18.1622 17.3521 18.246 16.8221 18.2893C16.2871 18.333 15.607 18.3333 14.6667 18.3333V19.1667C15.5932 19.1667 16.3132 19.167 16.8899 19.1199C17.4715 19.0723 17.9441 18.9745 18.3691 18.7579L17.9908 18.0154ZM19.2654 16.7408C18.9858 17.2896 18.5396 17.7358 17.9908 18.0154L18.3691 18.7579C19.0747 18.3984 19.6484 17.8247 20.0079 17.1191L19.2654 16.7408ZM19.5833 13.4167C19.5833 14.357 19.583 15.0371 19.5393 15.5721C19.496 16.1021 19.4122 16.4528 19.2654 16.7408L20.0079 17.1191C20.2245 16.6941 20.3223 16.2215 20.3699 15.6399C20.417 15.0632 20.4167 14.3432 20.4167 13.4167H19.5833ZM19.5833 8.25V13.4167H20.4167V8.25H19.5833ZM19.2654 4.92586C19.4122 5.21385 19.496 5.56453 19.5393 6.0946C19.583 6.62954 19.5833 7.3097 19.5833 8.25H20.4167C20.4167 7.32345 20.417 6.60349 20.3699 6.02674C20.3223 5.44514 20.2245 4.97258 20.0079 4.54754L19.2654 4.92586ZM17.9908 3.65123C18.5396 3.93086 18.9858 4.37706 19.2654 4.92586L20.0079 4.54754C19.6484 3.84193 19.0747 3.26825 18.3691 2.90873L17.9908 3.65123ZM14.6667 3.33333C15.607 3.33333 16.2871 3.33366 16.8221 3.37736C17.3521 3.42067 17.7028 3.50449 17.9908 3.65123L18.3691 2.90873C17.9441 2.69215 17.4715 2.59432 16.8899 2.5468C16.3132 2.49968 15.5932 2.5 14.6667 2.5V3.33333ZM11.0716 3.33333H14.6667V2.5H11.0716V3.33333ZM3.33333 1.66667H6.42957V0.833333H3.33333V1.66667ZM11.0716 2.5C10.4117 2.5 9.74231 2.14766 8.94941 1.71716C8.20749 1.31433 7.34206 0.833333 6.42957 0.833333V1.66667C7.08949 1.66667 7.75888 2.019 8.55178 2.44951C9.29371 2.85234 10.1591 3.33333 11.0716 3.33333V2.5Z"
        fill="url(#paint0_linear_4083_29762)"
        mask="url(#path-1-inside-1_4083_29762)"
      />
      <rect
        x="0.208333"
        y="5.625"
        width="19.5833"
        height="12.9167"
        rx="3.125"
        fill="#FEAE29"
        stroke="url(#paint1_linear_4083_29762)"
        stroke-width="0.416667"
      />
      <rect
        opacity="0.2"
        y="5.41666"
        width="20"
        height="13.3333"
        rx="3.33333"
        fill="url(#paint2_linear_4083_29762)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4083_29762"
          x1="10"
          y1="1.25"
          x2="10"
          y2="18.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.12" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4083_29762"
          x1="10"
          y1="5.41666"
          x2="10"
          y2="18.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.12" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4083_29762"
          x1="0"
          y1="5.41666"
          x2="13.7539"
          y2="18.301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FolderIcon;
